import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ColumnsOne = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 2.5H4.5C3.94772 2.5 3.5 2.94772 3.5 3.5V13.5C3.5 14.0523 3.94772 14.5 4.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V3.5C13.5 2.94772 13.0523 2.5 12.5 2.5ZM4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5V13.5C2.5 14.6046 3.39543 15.5 4.5 15.5H12.5C13.6046 15.5 14.5 14.6046 14.5 13.5V3.5C14.5 2.39543 13.6046 1.5 12.5 1.5H4.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ColumnsOne
